import SubPageHeader from './SubPageHeader';

export default SubPageHeader;
